






























import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class CentralInsert extends Vue {
    @Prop( { default: "" }) public title!: string;
    @Prop( { default: "" }) public subtitle!: string;
    @Prop( { default: null }) public enterpriseLogo!: string;
    @Prop( { default: false }) public display!: boolean;
}
